import React from 'react';
import Navbar from './Navbar';

const Home = () => {
  return (
    <>
      <Navbar title={'SciNet Portal'}/>
      <div style={{'margin':'25px 0px 25px 0px'}}></div>
      <div className='container'>
        <div className='card horizontal light-blue lighten-5'>
          <div className='card-stacked'>
            <div className='card-content'>
              <span className='card-title'>Job Performance</span>
              <p>Visit <a href='https://my.scinet.utoronto.ca'>my.scinet</a> for job utilization and group priority.</p>
            </div>
          </div>
        </div>

        <div className='card horizontal light-blue lighten-5'>
          <div className='card-stacked'>
            <div className='card-content'>
              <span className='card-title'>Documentation</span>
              <p>See our <a href='https://docs.scinet.utoronto.ca'>wiki</a> for complete information about our systems.</p>
            </div>
          </div>
        </div>

        <div className='card horizontal light-blue lighten-5'>
          <div className='card-stacked'>
            <div className='card-content'>
              <span className='card-title'>Education</span>
              <p>We teach <a href='https://education.scinet.utoronto.ca'>classes</a> on parallel programming, scientific computing, and more.</p>
            </div>
          </div>
        </div>

        <div className='card horizontal light-blue lighten-5'>
          <div className='card-stacked'>
            <div className='card-content'>
              <span className='card-title'>Support</span>
              <p>Need help? Email us at <a href='mailto:support@scinet.utoronto.ca'>support@scinet.utoronto.ca.</a></p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
